export default class Plant {
  /**
   * Represents a plant type (elm, mint, etc...)
   *
   * @param id {number|null} Unique identifier
   * @param name {String} Plant name
   * @param description {String} Plant description
   * @param layerId {String} Identifier of the PlantationLayer the plant grows in
   * @param picture {String} Name of the SVG picture representing the plant, without extension.
   */
  constructor ({ id = null, name, description, layerId, picture }) {
    this.id = id
    this.name = name
    this.description = description
    this.layerId = layerId
    this.picture = picture
  }

  /**
   * @returns {string} Path to plant picture, to use as markers sources
   */
  getPicturePath () {
    return `./pictures/${this.layerId}/${this.picture}.svg`
  }

  /**
   * @returns {string} Path to plant smaller picture, to use as zone background pattern
   */
  getPatternPicturePath () {
    return `./pictures/${this.layerId}/${this.picture}_pattern.svg`
  }
}
